'use client';

import AnimateLines from '@components/animate-lines/AnimateLines';
import BreadCrumbs from '@components/breadcrumbs/BreadCrumbs';
import Switch from '@components/switch/Switch';
import ROUTES from '@lib/constants/routes';
import { handleStartPanoramaPreload } from '@lib/store/slices/ComponentsSlice';
import { ScrollTrigger } from '@lib/tools/gsap-init';
import ScrollHelperTransTwo from '@lib/tools/helpers/ScrollHelperTransTwo';
import { useViewport } from '@lib/tools/hooks/useViewport';
import { useRouter } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import style from './page.module.scss';

export default function TemplateInfrastructure({ children }) {
  const [toggleMobile, setToggleMobile] = useState(false);
  const [toggleDesk, setToggleDesk] = useState(false);
  const svgRef5 = useRef(null);
  const svgRef5Desc = useRef(null);
  const router = useRouter();

  const dispatch = useDispatch();

  const { isMobile } = useViewport();

  useEffect(() => {
    let st5;

    if (svgRef5.current && isMobile) {
      const element = svgRef5.current;

      st5 = ScrollTrigger?.create({
        trigger: element,
        start: 'center center',
        scroller: 'body',
        scrub: true,
        pin: false,
        onToggle: () => {
          setTimeout(() => {
            setToggleMobile(true);
            dispatch(handleStartPanoramaPreload(true));
          }, 500);
        },
      });
    }

    return () => {
      if (st5) {
        st5.kill();
      }
    };
  }, [isMobile, dispatch]);

  useEffect(() => {
    let st5;
    const smootherWrapper = document.querySelector('#smooth-wrapper');

    if (svgRef5Desc.current && !isMobile && smootherWrapper) {
      const element = svgRef5Desc.current;
      st5 = ScrollTrigger.create({
        trigger: element,
        start: 'center center',
        scroller: '#smooth-wrapper',
        scrub: true,
        pin: false,
        onToggle: () => {
          setTimeout(() => {
            setToggleDesk(true);
            dispatch(handleStartPanoramaPreload(true));
          }, 500);
        },
      });
    }

    return () => {
      if (st5) {
        st5.kill();
      }
    };
  }, [isMobile, dispatch]);

  return (
    <>
      <div className={style.bredCrumbs_block}>
        <BreadCrumbs
          item={{
            color: isMobile ? '#1c1c1c' : 'white',
            crumbs: [
              { id: 1, text: 'Главная', link: ROUTES.root },
              { id: 2, text: 'Инфраструктура' },
            ],
          }}
        />
      </div>
      <div className={style.parallaxContainer}>
        {!isMobile && (
          <div className={style.infraSvg} ref={svgRef5Desc}>
            <AnimateLines id='infrastructure-5' className={style.svgClassFifth} toggle={toggleDesk} />
          </div>
        )}
        {isMobile && (
          <div className={style.infraSvgMobFive} ref={svgRef5}>
            <AnimateLines id='infrastructure-5-mob' className={style.svgClassMobFive} toggle={toggleMobile} />
          </div>
        )}

        {children}
        <div className={style.landscapingPageButtonWrapper}>
          <Switch
            className={style.button}
            switchText='Выбрать квартиру'
            black
            handleSwitch={() => router.push(ROUTES.flats.list)}
            testId='infrastructureFormOpen'
          />
        </div>
        <ScrollHelperTransTwo />
      </div>
    </>
  );
}
